import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  constructor(private swUpdate: SwUpdate) {
    this.listenForUpdates();
  }

  private listenForUpdates(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.notifyUserAndReload();
        }
      });
    } else {
      console.log('Service Worker is not enabled.');
    }
  }

  private notifyUserAndReload(): void {
    if (confirm('New version available. Reload to update?')) {
      window.location.reload();
    }
  }
}
